import CustomLottingList from '../../components/CustomLottingList';

const LottingList = () => {
  return <CustomLottingList normative="ehe" />;
};

export default LottingList;
